import { useContext } from 'react';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { LinearProgress, Card, CardContent, CardHeader } from '@occc-app/design-system';

import LocationScanDataFormContent from '../../components/LocationScanDataFormContent';
import { LocationContext } from '../LocationProvider';

export const LocationScanDataEdit = () => {
  const { loading } = useContext(LocationContext);
  return (
    <Card>
      {loading && <LinearProgress />}
      <CardHeader
        title={
          <Typography component='span' variant='h6'>
            Altria
          </Typography>
        }
      />
      <CardContent>
        <Grid container columnSpacing={3} rowSpacing={2}>
          <Grid md={12}>
            <LocationScanDataFormContent />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
